import React, { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useLocalStorage } from '@dentalux/common';
import { Button, Typography } from '@mui/material';
import { CrossButton } from 'src/components/CrossButton/CrossButton';
import { RedPill } from 'src/components/RedPill/RedPill';
import { SUPPLEMENTARY_INSURANCE_DISMISSAL_AT_KEY } from 'src/hooks/api/useSupplementaryInsuranceDismissal';
import useIsDesktop from 'src/hooks/useIsDesktop';
import useIsMobile from 'src/hooks/useIsMobile';
import Section from '../Section';
import * as S from './SupplementaryInsuranceSection.styles';
export const SupplementaryInsuranceSection = () => {
  const {
    t
  } = useTranslation();
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();
  const router = useRouter();
  const [, setValue] = useLocalStorage(SUPPLEMENTARY_INSURANCE_DISMISSAL_AT_KEY);
  const [dismissed, setDismissed] = useState(false);
  const supplementaryInsuranceRedirect = '/supplementary-insurance';
  useEffect(() => {
    router.prefetch(supplementaryInsuranceRedirect);
  }, [router.prefetch]);
  if (dismissed) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Section, {
    title: t('b2c.home.subheading.insurance'),
    extra: /*#__PURE__*/React.createElement(CrossButton, {
      onClick: () => {
        setDismissed(true);
        setValue(new Date().toISOString());
      }
    })
  }, /*#__PURE__*/React.createElement(S.Card, {
    headerStyles: {
      whiteSpace: 'normal'
    },
    Extra: /*#__PURE__*/React.createElement(RedPill, null, t('b2c.home.subheading.insurancePill')),
    Title: /*#__PURE__*/React.createElement(Typography, {
      variant: isDesktop ? 'Lato H5 Bold' : 'Lato Emphasized 1'
    }, t('b2c.home.subheading.insuranceTitle'))
  }, /*#__PURE__*/React.createElement(S.Content, null, /*#__PURE__*/React.createElement(S.Text, null, t('b2c.home.insurance.body')), /*#__PURE__*/React.createElement(S.Image, {
    width: 84
  })), /*#__PURE__*/React.createElement(Button, {
    size: isMobile ? 'xs' : 'sm',
    fullWidth: true,
    onClick: () => router.push(supplementaryInsuranceRedirect),
    variant: "bordered"
  }, t('b2c.home.insurance.button'))));
};